
import $ from 'jquery';

const prefix = "clf2020";

const initializeMenu = () => {

  const cache = {
    menu: document.querySelector(`#${prefix}-page-menu`)
  };

  if (cache.menu) {
    const hamMenu = cache.menu.querySelector(`.${prefix}-header-hamburger`);
    if (hamMenu) {
      Object.assign(cache, { hamMenu: hamMenu })

      const navContainer = cache.hamMenu.querySelector(".menu-clf-main-menu-container"),
        sandwichMenuContainer = cache.hamMenu.querySelector(".vce-sandwich-menu-container"),
        closeBtnHamMenu = sandwichMenuContainer.querySelector(".vce-sandwich-menu-close-button"),
        openBtnHamMenu = cache.hamMenu.querySelector(".vce-sandwich-menu-open-button"),
        navUnorderList = navContainer.querySelector("ul");

      // required to remove any default VC event
      const closeBtnClone = $(closeBtnHamMenu).clone();

      // Replace original node in order to override default events
      $(closeBtnHamMenu).replaceWith(closeBtnClone);

      Object.assign(cache, {
        mainMenuContainer: $(navContainer)[0],
        closeBtn: $(sandwichMenuContainer).find(".vce-sandwich-menu-close-button"),
        menuContainer: sandwichMenuContainer,
        nav: navUnorderList,
        openBtn: openBtnHamMenu
      });

      if (cache.nav) {
        $(cache.nav).addClass(`${prefix}-menu`);

        const subMenus = $(cache.nav).find(".menu-item.menu-item-has-children");

        if (subMenus.length > 0) {
          let cloneSubItem = {};
          $.each(subMenus, function (index, submenu) {
            
            if ($(submenu).children("a").length) {
              const anchorOfLi = $(submenu).children()[0];

              if($(anchorOfLi).attr("href")){ //If it does have a href. This is because VC exec twice

                const addNewLi = $(anchorOfLi).clone();

                anchorOfLi.removeAttribute("href"); // Remove the href so it does not redirect to a new page

                const newLi = `<li class="menu-item menu-item-type-post_type menu-item-object-page"><a href="${addNewLi.attr('href')}">${addNewLi.html()}</a></li>`
                $($(submenu).children()[1]).prepend(newLi); // Prepend the new <li> with the <a> and the href deleted previously
              }

            }
            cloneSubItem = $(submenu).clone();  // required to remove any default VC event
            animateSubMenu(cloneSubItem, submenu);
          });
        }
      }

    }
  }

  initListeners(cache);
};

const animateSubMenu = (clone, origin) => {
  // Replace original node in order to override default events
  $(origin).replaceWith(clone);

  $(clone).find("a").click(function (event) {
    $(this).parent().addClass("menu-sub-active");
    $(this).parent().parent().addClass("menu-sub-active");
  });

  const subItems = $(clone).find(".sub-menu");

  if (subItems) {

    // Adds the arrow <li> and checks if already exist to avoid duplicity
    $.each(subItems, function (index, item) {
      let exist = false;
      $.each(item.children, function (index, itemUl) {
        if ($(itemUl).hasClass("submenu-back")) {
          exist = true;
        }
      });

      if (!exist) {
        $(item).append("<li class='submenu-back'><a href='#' class='item-arrow'></a></li>");
      }
    });

    // Submenu back button listener
    $(subItems).find(".item-arrow").click(function (ev) {
      ev.preventDefault();
      $(this).parents().eq(2).removeClass("menu-sub-active");
      $(this).parents().eq(3).removeClass("menu-sub-active");
    });
  }
};

const initListeners = (cacheObj) => {

  const bodyDOM = $("body");

  $(bodyDOM).addClass("mobile-menu-close");

  // open menu
  $(cacheObj.openBtn).click(function (event) {
    event.stopPropagation();
    bodyDOM.removeClass("mobile-menu-close").addClass("mobile-menu-open");
    bodyDOM.removeAttr("style");
    return false;
  });

  $(cacheObj.closeBtn).click(function (event) {
    bodyDOM.removeClass("mobile-menu-open").addClass("mobile-menu-close");

    //  reset submenu
    $(cacheObj.mainMenuContainer).find(".menu-sub-active").removeClass("menu-sub-active");
  });
};

const deleteParentHover = () => {
  const menu = $(`.${prefix}-header-menu .menu-clf-main-menu-container .menu li`);

  menu.each(function (i) {
    if ($(this).hasClass("menu-item-has-children")) {
      const parent = $(this);
      const ulSubMenu = $(this).find("ul")

      ulSubMenu.mouseenter(function () {
        parent.addClass("hide-underline");
      });

      ulSubMenu.mouseleave(function () {
        parent.removeClass("hide-underline").addClass("show-underline");
      });
    }
  });
}

document.addEventListener("readystatechange", (event) => {
  $(function () {
    initializeMenu();
    deleteParentHover();
  });
}, false);